<template>
  <div class="page">
    <Menu />
    <div class="registerContent">
      <div class="form-box">
        <div class="img-box">
          <img class="img" src="/img/login_bg.png" alt />
        </div>
        <div class="form">
          <div class="title">重置密码</div>
          <div class="item">
            <span class="iconfont icon-android"></span>
            <input type="text" v-model="mobile" maxlength="11" name="mobile" placeholder="请输入您的电话号码" />
          </div>
          <div class="item">
            <span class="iconfont icon-mima"></span>
            <input type="password" v-model="password" maxlength="16" name="password" placeholder="请输入您的密码" />
          </div>
          <div class="item validateCode">
            <input
              type="text"
              v-model="validateCode"
              name="validateCode"
              maxlength="6"
              minlength="1"
              placeholder="请输入您的验证码"
            />
            <div class="sendValdateCode" @click="sendSmsCode">{{validateCodeText}}</div>
          </div>
          <div class="register_button" @click="forgetFun">重置密码</div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from "@/components/Menu2.vue";
import Footer from "@/components/Footer.vue";
import { smgForgetCode, forgetPwd } from "@/api/account.js";

export default {
  data() {
    return {
      mobile: "", 
      password: "",
      validateCode: "",
      validateCodeText: "获取验证码", //获取验证码所在的控件提示文字
      timer: 0 //定时器
    };
  },
  components: {
    Menu,
    Footer
  },

  methods: {
    sendSmsCode: function() {
      if (!this.mobile) {
        this.$message({
          message: "手机号码不能为空",
          type: "warning"
        });
        return;
      }
      let that = this;
      smgForgetCode(this.mobile).then(resp => {
        if (resp != -1) {
          this.timer = setInterval(function() {
            that.validateCodeText = resp + "秒内有效";
            if (resp > 1) {
              resp -= 1;
            } else {
              that.validateCodeText = "发送验证码";
              clearInterval(that.timer);
              that.timer = null;
            }
          }, 1000);
        }
      });
    },
    forgetFun: function() {
      if (!this.mobile) {
        this.$message({
          message: "手机号码不能为空",
          type: "warning"
        });
        return;
      }
      if (!this.password) {
        this.$message({
          message: "密码不能为空",
          type: "warning"
        });
        return;
      }
      if (!this.validateCode) {
        this.$message({
          message: "验证码不能为空",
          type: "warning"
        });
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "执行操作中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      forgetPwd(this.mobile, this.validateCode, this.password).then(resp => {
        loading.close();
        if (resp != -1) {
          this.$message({
            message: resp,
            type: "success"
          });
          setTimeout(() => {
            this.$router.push(`/login`);  
          }, 1500);
        }
      });
    }
  }
};
</script>


<style lang="scss" scoped>
body {
  background: #efefef;
}

.registerContent {
  background: #efefef url("/img/login_bg2.png") no-repeat center center;
  margin: 0 auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;

  .form-box {
    background: white;
    width: 1000px;
    margin: 60px auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .img-box {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-content: center;
      .img {
        width: 400px;
        background: #efefef;
        display: block;
        margin: 0 auto;
      }
    }
    .form {
      padding: 20px;
      margin: 40px 30px;
      .title {
        text-align: center;
        color: #313131;
        font-weight: bold;
        font-size: 1.8em;
      }
      .item {
        margin: 12px 0;
        border: 1px solid #bebebe;
        span {
          margin-left: 10px;
          color: #313131;
        }
        input {
          width: 300px;
          border: 0;
          outline: none;
          height: 40px;
          line-height: 40px;
          padding: 0 10px;
          color: #101010;
        }
      }
      .validateCode {
        position: relative;
        .sendValdateCode {
          cursor: pointer;
          background: #313131;
          width: 100px;
          position: absolute;
          top: 0;
          right: 0;
          height: 41px;
          line-height: 41px;
          color: white;
          text-align: center;
        }
      }
      .agreement {
        label {
          color: #767676;
          font-weight: 1.4em;
        }
        .agreement_page {
          color: #5d9bf9;
          font-size: 1.4em;
          text-decoration: underline;
        }
      }
      .register_button {
        cursor: pointer;
        font-weight: bold;
        font-size: 1.6em;
        color: white;
        background: #313131;
        padding: 10px;
        text-align: center;
        margin-top: 30px;
      }
      .go_login {
        margin: 15px 0;
        font-size: 1.4em;
        color: #b8b8b8;
        a {
          color: #313131;
        }
      }
    }
  }
  //重置底部margin-top;
}

.footer-box {
  margin-top: 0;
}
</style>